import { QuizVideo } from "./QuizVideo";
// eslint-disable-next-line import/no-anonymous-default-export
export default {
    QuizVideo,
};
